export default "__VITE_ASSET__x8g9MOhn__"